import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/**
 * PwaUpdateBanner — non-invasive prompt when a new SW version is available.
 * Listens to the `pwa-update-available` event dispatched by index.js.
 */
export default function PwaUpdateBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onUpd = () => setVisible(true);
        window.addEventListener("pwa-update-available", onUpd);
        return () => window.removeEventListener("pwa-update-available", onUpd);
    }, []);

    if (!visible) return null;
    const reload = () => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistration().then((reg) => {
                if (reg?.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
                setTimeout(() => window.location.reload(), 150);
            });
        } else {
            window.location.reload();
        }
    };

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-[hsl(var(--primary))] text-white rounded-full shadow-lg px-4 py-2 flex items-center gap-3 text-sm" data-testid="pwa-update-banner">
            <span>È disponibile una nuova versione</span>
            <button onClick={reload} className="flex items-center gap-1 underline underline-offset-2" data-testid="pwa-update-reload">
                <RefreshCw className="w-3.5 h-3.5" strokeWidth={1.5} />
                Aggiorna
            </button>
        </div>
    );
}
